<template>
	<h3 class="title mb_20 tal">{{ $t('c2c.check.title') }}</h3>
	<div class="d_flex account_box_wrap">
		<div v-if="sourceAsset.is_active === 'Y'" class="source_box w50">
			<div
				v-if="!sourceAccount"
				class="account_box no_account"
				@click="$emit('createAccount', sourceAsset.seq)"
			>
				<div :class="'icon ' + sourceAsset.code"></div>
				<p class="coin_name">
					{{ sourceAsset.code }} <br />
					<span>{{ sourceAsset.title }}</span>
				</p>
				<p class="value">{{ $t('c2c.check.text1') }}</p>
				<div class="status_icon ADD"></div>
			</div>
			<div v-else class="account_box">
				<div :class="'icon ' + sourceAccount.asset_code"></div>
				<p class="coin_name">
					{{ sourceAccount.asset_code }} <br />
					<span>{{ sourceAccount.asset_title }}</span>
				</p>
				<p class="value">
					<span>{{ sourceAccount.balance }}</span>
					{{ sourceAccount.asset_code }}
				</p>
				<div class="status_icon success"></div>
			</div>
		</div>
		<div v-if="targetAsset.is_active === 'Y'" class="target_box w50">
			<div
				v-if="!targetAccount"
				class="account_box no_account"
				@click="$emit('createAccount', targetAsset.seq)"
			>
				<div :class="'icon ' + targetAsset.code"></div>
				<p class="coin_name">
					{{ targetAsset.code }} <br />
					<span>{{ targetAsset.title }}</span>
				</p>
				<p class="value">{{ $t('c2c.check.text1') }}</p>
				<div class="status_icon ADD"></div>
			</div>
			<div v-else class="account_box">
				<div :class="'icon ' + targetAccount.asset_code"></div>
				<p class="coin_name">
					{{ targetAccount.asset_code }} <br />
					<span>{{ targetAccount.asset_title }}</span>
				</p>
				<p class="value">
					<span>{{ targetAccount.balance }}</span>
					{{ targetAccount.asset_code }}
				</p>
				<div class="status_icon success"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'CheckAccount',
	emits: ['createAccount'],
	props: {
		sourceAssetSeq: {
			type: Number,
		},
		targetAssetSeq: {
			type: Number,
		},
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets', 'registedAssets']),
		sourceAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.sourceAssetSeq;
			});
		},
		targetAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.targetAssetSeq;
			});
		},
		sourceAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.sourceAssetSeq;
			});
		},
		targetAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.targetAssetSeq;
			});
		},
	},
};
</script>
